import { render, staticRenderFns } from "./log_item.vue?vue&type=template&id=4e2c172b&scoped=true"
import script from "./log_item.vue?vue&type=script&lang=js"
export * from "./log_item.vue?vue&type=script&lang=js"
import style0 from "./log_item.vue?vue&type=style&index=0&id=4e2c172b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2c172b",
  null
  
)

export default component.exports